module.exports = __webpack_public_path__ + "img/gall-3.5a098d84.jpg";